<template>
  <div>
    <div align="right" style="margin: 10px">
      <Button color="primary" @click="add">新增</Button>
    </div>
    <Table :datas="accountList" :border="true" :loading="loading">
      <TableItem title="账户名称" prop="name"></TableItem>
      <TableItem title="类型" :width="100" align="center">
        <template slot-scope="{data}">
          {{ data.type === 2 ? '银行' : '现金' }}
        </template>
      </TableItem>
      <TableItem title="对应科目">
        <template slot-scope="{data}">
          {{ subjectName(data.subjectId) }}
        </template>
      </TableItem>
      <TableItem title="期初余额" :width="140" align="right">
        <template slot-scope="{data}">
          {{ data.initialBalance | numFormat }}
        </template>
      </TableItem>
      <TableItem title="操作" width="140">
        <div class="actions" slot-scope="{data}">
          <span @click="edit(data)">编辑</span>
          <span @click="remove(data)">删除</span>
        </div>
      </TableItem>
    </Table>
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">资金账户</div>
      <Form ref="form" v-width="420" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="账户名称" prop="name">
          <input type="text" v-model="form.name">
        </FormItem>
        <FormItem label="类型" prop="type">
          <Select v-model="form.type" :datas="typeList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="对应科目" prop="subjectId">
          <Select v-model="form.subjectId" :datas="subjectList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
        <FormItem label="期初余额" prop="initialBalance">
          <NumberInput v-model="form.initialBalance"></NumberInput>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const emptyForm = {
  name: '',
  type: 1,
  subjectId: null,
  initialBalance: 0
};

export default {
  name: "FundsAccount",
  data() {
    return {
      accountList: [],
      subjectList: [],
      typeList: [{id: 1, name: '现金'}, {id: 2, name: '银行'}],
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['name', 'type']
      },
      showForm: false,
      loading: false
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      Promise.all([
        this.$api.funds.account.list(),
        this.$api.setting.subject.voucherSelect({})
      ]).then((results) => {
        this.accountList = results[0].data || [];
        this.subjectList = results[1].data || [];
      }).finally(() => this.loading = false);
    },
    subjectName(subjectId) {
      if (!subjectId) {
        return '-';
      }
      let subject = this.subjectList.find(val => val.id === subjectId);
      return subject ? `${subject.code}-${subject.name}` : '-';
    },
    add() {
      this.form = Object.assign({}, emptyForm);
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.$api.funds.account[this.form.id ? 'update' : 'save'](this.form).then(() => {
          this.$Message('保存成功~');
          this.showForm = false;
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      }
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.funds.account.delete(data.id).then(() => {
          this.loadList();
        })
      })
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>
